import { AppService } from './app-service';

/**
 * Send new invitation link
 */
export function SendNewInvitationLink(token: string): Promise<Response> {
    let body = JSON.stringify({ token });
    return AppService.Post('openinvitation/sendNewInvitationLink', body);
}